var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5878 6.80037C18.5631 0.662374 13.8106 0 12 0C10.1894 0 5.43692 0.662374 0.412186 6.81214C-0.137395 7.48577 -0.137395 8.51423 0.412186 9.18786C5.43428 15.3347 10.192 16 12 16C13.808 16 18.5631 15.3347 23.5878 9.17608C24.1374 8.50246 24.1374 7.47399 23.5878 6.80037ZM12 14C14.852 14 18.3457 12.4065 21.9754 7.98836C18.3464 3.58684 14.855 2 12 2C9.1441 2 5.65339 3.58927 2.02456 8C5.65171 12.4084 9.14751 14 12 14ZM11.9429 4.00008C14.1671 3.98616 15.9824 5.77602 16 8.00024C15.9998 10.202 14.2204 11.9896 12.0188 12C9.81712 12.0103 8.02105 10.2394 8.00018 8.03775C7.97931 5.8361 9.74149 4.0315 11.9429 4.00008ZM10.0001 8.0188C10.0105 9.11969 10.9086 10.0051 12.0094 9.99998C13.1102 9.99482 13.9999 9.10098 14.0001 8.01606C13.9912 6.89775 13.0807 5.99733 11.9635 6.00001C10.8665 6.01996 9.98968 6.92057 10.0001 8.0188ZM1.96186 8.07646L1.96511 8.07249L1.97052 8.06552L1.96186 8.07646Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5878 6.80037C18.5631 0.662374 13.8106 0 12 0C10.1894 0 5.43692 0.662374 0.412186 6.81214C-0.137395 7.48577 -0.137395 8.51423 0.412186 9.18786C5.43428 15.3347 10.192 16 12 16C13.808 16 18.5631 15.3347 23.5878 9.17608C24.1374 8.50246 24.1374 7.47399 23.5878 6.80037ZM12 14C14.852 14 18.3457 12.4065 21.9754 7.98836C18.3464 3.58684 14.855 2 12 2C9.1441 2 5.65339 3.58927 2.02456 8C5.65171 12.4084 9.14751 14 12 14ZM11.9429 4.00008C14.1671 3.98616 15.9824 5.77602 16 8.00024C15.9998 10.202 14.2204 11.9896 12.0188 12C9.81712 12.0103 8.02105 10.2394 8.00018 8.03775C7.97931 5.8361 9.74149 4.0315 11.9429 4.00008ZM10.0001 8.0188C10.0105 9.11969 10.9086 10.0051 12.0094 9.99998C13.1102 9.99482 13.9999 9.10098 14.0001 8.01606C13.9912 6.89775 13.0807 5.99733 11.9635 6.00001C10.8665 6.01996 9.98968 6.92057 10.0001 8.0188ZM1.96186 8.07646L1.96511 8.07249L1.97052 8.06552L1.96186 8.07646Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eye_open.4a523c34.svg";
export { ForwardRef as ReactComponent };